<!-- Hero Start -->
<section class="main-slider" id="home">
  <ngb-carousel class="slides" [showNavigationArrows]="showNavigationArrows"
    [showNavigationIndicators]="showNavigationIndicators">
    <ng-template ngbSlide>
      <li class="bg-home bg-animation-left d-flex align-items-center"
        style="background-image:url('assets/images/hotel/bg01.jpg')">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-7 col-md-7">
              <div class="title-heading position-relative mt-4" style="z-index: 1;">
                <h1 class="heading mb-3">Enjoy Better Holidays With Blimp </h1>
                <p class="para-desc">Unleash your ambition and travel to any place you wish.</p>
                <div class="watch-video mt-4 pt-2">
                  <a (click)="openWindowCustomClass(content)" href="javascript:void(0);" data-type="youtube"
                    data-id="yba7hPeTSjk" class="btn btn-icon btn-pills btn-primary">
                    <i-feather name="video" class="icons"></i-feather>
                  </a><span class="fw-bold text-uppercase small align-middle ms-2">Watch Now</span>
                  <ng-template #content let-modal>
                    <div class="modal-header">
                      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <youtube-player [videoId]="'yba7hPeTSjk'" height="450" width="780">
                      </youtube-player>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ng-template>
    <ng-template ngbSlide>
      <li class="bg-home bg-animation-left d-flex align-items-center"
        style="background-image:url('assets/images/hotel/bg02.jpg')">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-7 col-md-7">
              <div class="title-heading position-relative mt-4" style="z-index: 1;">
                <h1 class="heading mb-3">Enjoy The World of Relaxation</h1>
                <p class="para-desc">Unleash your ambition and travel to any place you wish.</p>
                <div class="watch-video mt-4 pt-2">
                  <a routerLink="/page-aboutus" class="btn btn-primary"><i class="uil uil-briefcase"></i> Aboutus</a>
                </div>
              </div>
            </div>
            
          </div>
         
          
        </div>
      </li>
    </ng-template>
    <ng-template ngbSlide>
      <li class="bg-home bg-animation-left d-flex align-items-center"
        style="background-image:url('assets/images/hotel/bg03.jpg')">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-7 col-md-7">
              <div class="title-heading position-relative mt-4" style="z-index: 1;">
                <h1 class="heading mb-3">Welcome Blimp <br> A Stunning App</h1>
                <p class="para-desc">Unleash your ambition and travel to any place you wish.</p>
                <div class="mt-4 pt-2">
                  <a [ngxScrollTo]="'#bookroom'" class="btn btn-primary"><i class="uil uil-home"></i> Book now</a>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </li>
    </ng-template>
  </ngb-carousel>
</section>
<!--end section-->
<!-- Hero End -->
<section class="section-two bg-light" id="bookroom">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-12">
        <form class="p-4 shadow rounded">
          <h4 class="mb-3">Book Now !</h4>
          <div class="row text-start">
            <div class="col-lg-3 col-md-6">
              <div class="mb-3 mb-lg-0">
                <label class="form-label"> Check in : </label>
                <input type="text" class="form-control" name="picker" id="checkin" [(ngModel)]="checkin" mwlFlatpickr
                [altInput]="true" [convertModelValue]="true">
              </div>
            </div>
            <!--end col-->

            <div class="col-lg-3 col-md-6">
              <div class="mb-3 mb-lg-0">
                <label class="form-label"> Check out : </label>
                <input type="text" class="form-control" name="checkoutpicker" id="checkout" [(ngModel)]="checkout"
                [altInput]="true" mwlFlatpickr [convertModelValue]="true">
              </div>
            </div>
            <!--end col-->

            <div class="col-lg-6">
              <div class="row align-items-center">
                <div class="col-md-4">
                  <div class="mb-3 mb-lg-0">
                    <label class="form-label">City : </label>
                    <input type="text" min="0" autocomplete="off" id="adult" required="" class="form-control"
                      placeholder="City :">
                  </div>
                </div>
                <!--end col-->

                <div class="col-md-4">
                  <div class="mb-3 mb-lg-0">
                    <label class="form-label">Location : </label>
                    <input type="text" min="0" autocomplete="on" id="children" class="form-control"
                      placeholder="Location :">
                  </div>
                </div>
                <!--end col-->

                <div class="col-md-4 mt-lg-4 pt-2 pt-lg-1">
                  <div class="d-grid">
                    <input type="submit" id="search" name="search" class="searchbtn btn btn-primary" value="Search">
                  </div>
                </div>
                <!--end col-->
              </div>
            </div>
          </div>
        </form>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>
  <!--end container-->
</section>

<div class="position-relative">
  <div class="shape overflow-hidden text-color-white">
    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
    </svg>
  </div>
</div>
<!-- Hero End -->

<section class="section">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 text-center">
        <div class="section-title mb-4 pb-2">
          <h4 class="title mb-4">Benefit for Traveller</h4>
          <p class="text-muted para-desc mb-0 mx-auto">Start Travelle with <span
              class="text-primary fw-bold">Blimp</span> that can provide everything you need to generate
            awareness, drive traffic, connect.</p>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->



        <div class="row">
      <div class="breadcrumb-item col-lg-4 col-md-4 mt-4 pt-2"  routerLink="/events-world" >
        <div
          class="card features feature-primary feature-full-bg rounded p-4 bg-light text-center position-relative overflow-hidden border-0">
          <span class="h1 icon-color">
            <i class="uil uil-globe"></i>
          </span>
          <div class="card-body p-0 content">
            <h5>Events World</h5>
            <p class="para text-muted mb-0">It is a long established fact that a reader.</p>
          </div>
        </div>
      </div>
      <!--end col-->

      <div class="col-lg-4 col-md-4 mt-4 pt-2" routerLink="/camps">
        <div
          class="card features feature-primary feature-full-bg rounded p-4 bg-light text-center position-relative overflow-hidden border-0">
          <span class="h1 icon-color">
            <i class="uil uil-map-pin"></i>
          </span>
          <div class="card-body p-0 content">
            <h5>Camping</h5>
            <p class="para text-muted mb-0">It is a long established fact that a reader.</p>
          </div>
        </div>
      </div>
      <!--end col-->

      <div class="col-lg-4 col-md-4 mt-4 pt-2" routerLink="/foods">
        <div
          class="card features feature-primary feature-full-bg rounded p-4 bg-light text-center position-relative overflow-hidden border-0" >
          <span class="h1 icon-color">
            <i class="uil uil-coffee"></i>
          </span>
          <div class="card-body p-0 content">
            <h5>Foods</h5>
            <p class="para text-muted mb-0">It is a long established fact that a reader.</p>
          </div>
        </div>
      </div>
      <!--end col-->

      <div class="col-lg-4 col-md-4 mt-4 pt-2" routerLink="/experiences">
        <div
          class="card features feature-primary feature-full-bg rounded p-4 bg-light text-center position-relative overflow-hidden border-0">
          <span class="h1 icon-color">
            <i class="uil uil-camera"></i>
          </span>
          <div class="card-body p-0 content">
            <h5> Experience</h5>
            <p class="para text-muted mb-0">It is a long established fact that a reader.</p>
          </div>
        </div>
      </div>
      <!--end col-->

      <!-- <div class="col-lg-3 col-md-4 mt-4 pt-2">
        <div
          class="card features feature-primary feature-full-bg rounded p-4 bg-light text-center position-relative overflow-hidden border-0" routerLink="/adventures">
          <span class="h1 icon-color">
            <i class="uil uil-umbrella"></i>
          </span>
          <div class="card-body p-0 content">
            <h5>Adventures</h5>
            <p class="para text-muted mb-0">It is a long established fact that a reader.</p>
          </div>
        </div>
      </div> -->
      <!--end col-->

      <div class="col-lg-4 col-md-4 mt-4 pt-2"  routerLink="/souvenirs">
        <div
          class="card features feature-primary feature-full-bg rounded p-4 bg-light text-center position-relative overflow-hidden border-0">
          <span class="h1 icon-color">
            <i class="uil uil-gift"></i>
          </span>
          <div class="card-body p-0 content">
            <h5>Souvenirs</h5>
            <p class="para text-muted mb-0">It is a long established fact that a reader.</p>
          </div>
        </div>
      </div>
      <!--end col-->

      <div  class="col-lg-4 col-md-4 mt-4 pt-2 "  routerLink="/visas" >
        <div
          class="card features feature-primary feature-full-bg rounded p-4 bg-light text-center position-relative overflow-hidden border-0">
          <span class="h1 icon-color">
            <i class="uil uil-info" ></i>
          </span>
          <div class="card-body p-0 content">
            <h5>Visa Information</h5>
            <p class="para text-muted mb-0">It is a long established fact that a reader.</p>
          </div>
        </div>
      </div>
      <!--end col-->

      <!-- <div class="col-lg-3 col-md-4 mt-4 pt-2">
        <div
          class="card features feature-primary feature-full-bg rounded p-4 bg-light text-center position-relative overflow-hidden border-0">
          <span class="h1 icon-color">
            <i class="uil uil-map"></i>
          </span>
          <div class="card-body p-0 content">
            <h5>Something else</h5>
            <p class="para text-muted mb-0">It is a long established fact that a reader.</p>
          </div>
        </div>
      </div> -->
      <!--end col-->

      <div class="col-lg-12 text-center col-md-4 mt-4 pt-2">
        <a href="javascript:void(0)" class="btn btn-primary">See more
          <i-feather name="arrow-right" class="fea icon-sm"></i-feather>
        </a>
      </div>
      <!--end col-->
    </div>
    
    <!--end row-->
  </div>
  <!--end container-->

  <div class="container mt-100 mt-60">
    <div class="row align-items-end mb-4 pb-2">
      <div class="col-md-8">
        <div class="section-title text-md-left">
          <h6 class="text-primary">Find Out Most</h6>
          <h4 class="title mb-4">Popular Destination</h4>
          <p class="text-muted mb-0 para-desc">Start working with <span class="text-primary fw-bold">Blimp</span>
            that can provide everything you need to generate
            awareness, drive traffic, connect.</p>
        </div>
      </div>
      <!--end col-->

      <div class="col-md-4 mt-4 mt-sm-0">
        <div class="text-center text-md-end">
          <a href="javascript:void(0)" class="text-primary h6">See More
            <i-feather name="arrow-right" class="fea icon-sm"></i-feather>
          </a>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>
  <!--end container-->
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12 mt-4 pt-2">
        <owl-carousel-o id="six-slide"  [options]="customOptionsLocations" class="owl-stage-outer">
          <ng-template   *ngFor="let item of countryList" carouselSlide>
            <div class="popular-tour rounded-md position-relative overflow-hidden mx-3" (click)="EventDetails(item.id)">
              <img src="{{item.imageURL}}" class="img-fluid" alt="">
              <div class="overlay-work bg-dark"></div>
              <div class="content">
                <a  class="title text-white h4 title-dark">{{item.nameEn}}</a>
              </div>
            </div>
          </ng-template>
          <!-- <ng-template carouselSlide>
            <div class="popular-tour rounded-md position-relative overflow-hidden mx-3">
              <img src="assets/images/travel/dubai.jpg" class="img-fluid" alt="">
              <div class="overlay-work bg-dark"></div>
              <div class="content">
                <a href="javascript:void(0)" class="title text-white h4 title-dark">Dubai</a>
              </div>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="popular-tour rounded-md position-relative overflow-hidden mx-3">
              <img src="assets/images/travel/thailand.jpg" class="img-fluid" alt="">
              <div class="overlay-work bg-dark"></div>
              <div class="content">
                <a href="javascript:void(0)" class="title text-white h4 title-dark">Thailand</a>
              </div>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="popular-tour rounded-md position-relative overflow-hidden mx-3">
              <img src="assets/images/travel/india.jpg" class="img-fluid" alt="">
              <div class="overlay-work bg-dark"></div>
              <div class="content">
                <a href="javascript:void(0)" class="title text-white h4 title-dark">India</a>
              </div>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="popular-tour rounded-md position-relative overflow-hidden mx-3">
              <img src="assets/images/travel/london.jpg" class="img-fluid" alt="">
              <div class="overlay-work bg-dark"></div>
              <div class="content">
                <a href="javascript:void(0)" class="title text-white h4 title-dark">Londan</a>
              </div>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="popular-tour rounded-md position-relative overflow-hidden mx-3">
              <img src="assets/images/travel/paris.jpg" class="img-fluid" alt="">
              <div class="overlay-work bg-dark"></div>
              <div class="content">
                <a href="javascript:void(0)" class="title text-white h4 title-dark">Paris</a>
              </div>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="popular-tour rounded-md position-relative overflow-hidden mx-3">
              <img src="assets/images/travel/singapore.jpg" class="img-fluid" alt="">
              <div class="overlay-work bg-dark"></div>
              <div class="content">
                <a href="javascript:void(0)" class="title text-white h4 title-dark">Singapore</a>
              </div>
            </div>
          </ng-template> -->
        </owl-carousel-o>
        <!-- </div> -->
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>
</section>
<!--end section-->

<section class="section bg-light">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 text-center">
        <div class="section-title">
          <h4 class="title fw-bold mb-4">Everyone Needs Travel. <br> Want to Break Free for a While</h4>
          <p class="text-muted para-desc mb-0 mx-auto">Start working with <span
              class="text-primary fw-bold">Blimp</span> that can provide everything you need to generate awareness,
            drive traffic, connect.</p>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>
  <!--end container-->

  <div class="container mt-100 mt-60">
    <div class="row align-items-center">
      <div class="col-lg-5 col-md-6">
        <div class="card blog rounded border-0 shadow overflow-hidden">
          <div class="position-relative">
            <img src="assets/images/travel/1.jpg" class="card-img-top" alt="...">
            <div class="overlay rounded-top bg-dark"></div>
          </div>
          <div class="card-body content">
            <h5><a href="javascript:void(0)" class="card-title title text-dark">Conversations, Feedback, Recognition</a>
            </h5>
            <div class="post-meta d-flex justify-content-between mt-3">
              <ul class="list-unstyled mb-0">
                <li class="list-inline-item me-2 mb-0"><a href="javascript:void(0)" class="text-muted like"><i
                      class="uil uil-heart me-1"></i>33</a></li>
                <li class="list-inline-item"><a href="javascript:void(0)" class="text-muted comments"><i
                      class="uil uil-comment me-1"></i>08</a></li>
              </ul>
              <a routerLink="/page-blog-detail" class="text-muted readmore">Read More <i
                  class="uil uil-angle-right-b align-middle"></i></a>
            </div>
          </div>
          <div class="author">
            <small class="text-light user d-block"><i class="uil uil-user"></i> Calvin Carlo</small>
            <small class="text-light date"><i class="uil uil-calendar-alt"></i> 13th August, 2019</small>
          </div>
        </div>
      </div>
      <!--end col-->

      <div class="col-lg-7 col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
        <div class="section-title ms-lg-4">
          <h4 class="title mb-4">Experience Luxury & <br> Find Your Base</h4>
          <p class="text-muted">You can combine all the Blimp templates into a single one, you can take a component
            from the Application theme and use it in the Website.</p>
          <ul class="list-unstyled text-muted">
            <li class="mb-0"><span class="text-primary h5 me-2"><i
                  class="uil uil-check-circle align-middle"></i></span>Digital Marketing Solutions for Tomorrow</li>
            <li class="mb-0"><span class="text-primary h5 me-2"><i
                  class="uil uil-check-circle align-middle"></i></span>Our Talented & Experienced Marketing Agency</li>
            <li class="mb-0"><span class="text-primary h5 me-2"><i
                  class="uil uil-check-circle align-middle"></i></span>Create your own skin to match your brand</li>
          </ul>
          <a href="javascript:void(0)" class="mt-3 h6 text-primary">Search Destination <i
              class="uil uil-angle-right-b"></i></a>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>
  <!--end container-->

  <div class="container mt-100 mt-60">
    <div class="row align-items-center">
      <div class="col-lg-5 col-md-6 order-1 order-md-2">
        <img src="assets/images/travel/3.jpg" class="img-fluid rounded shadow-md" alt="">
      </div>
      <!--end col-->

      <div class="col-lg-7 col-md-6 order-2 order-md-1 mt-4 mt-sm-0 pt-2 pt-sm-0">
        <div class="section-title me-lg-5">
          <h4 class="title mb-4">100% Free <br> Travile Now</h4>
          <p class="text-muted">You can combine all the Blimp App into a single one, you can take a servese
            from the Mobile Application  and use it in the Website.</p>
        </div>

        <div class="faq-content mt-4 pt-2">
          <ngb-accordion #acc="ngbAccordion" activeIds="ngb-panel-0" closeOthers="true">
            <ngb-panel cardClass="border-0 rounded shadow mb-2">
              <ng-template ngbPanelTitle>
                <div class="border-0 bg-light" id="headingtwo">
                  <h6 class="title mb-0">How Blimp does it work ?
                  </h6>
                </div>
              </ng-template>
              <ng-template ngbPanelContent>
                <p class="text-muted mb-0 faq-ans">There are many serveses of citis of Lorem Ipsum available,
                  but
                  the majority have suffered alteration in some form.</p>
              </ng-template>
            </ngb-panel>
            <ngb-panel cardClass="border-0 rounded shadow mb-2">
              <ng-template ngbPanelTitle>
                <div class="border-0 bg-light" id="headingtwo">
                  <h6 class="title mb-0"> Do I need a designer to use Blimp ? </h6>
                </div>
              </ng-template>
              <ng-template ngbPanelContent>
                <p class="text-muted mb-0 faq-ans">There are many serveses of citis of Lorem Ipsum available,
                  but
                  the majority have suffered alteration in some form.</p>
              </ng-template>
            </ngb-panel>
            <ngb-panel cardClass="border-0 rounded shadow mb-2">
              <ng-template ngbPanelContent>
                <p class="text-muted mb-0 faq-ans">There are many serveses of citis of Lorem Ipsum available,
                  but
                  the majority have suffered alteration in some form.</p>
              </ng-template>
              <ng-template ngbPanelContent>
                <p class="text-muted mb-0 faq-ans">There are many serveses of citis of Lorem Ipsum available,
                  but
                  the majority have suffered alteration in some form.</p>
              </ng-template>
            </ngb-panel>
            <ngb-panel cardClass="border-0 rounded shadow mb-2">
              <ng-template ngbPanelContent>
                <p class="text-muted mb-0 faq-ans">There are many serveses of citis of Lorem Ipsum available,
                  but
                  the majority have suffered alteration in some form.</p>
              </ng-template>
              <ng-template ngbPanelContent>
                <p class="text-muted mb-0 faq-ans">There are many serveses of citis of Lorem Ipsum available,
                  but
                  the majority have suffered alteration in some form.</p>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>

        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>
  <!--end container-->

  <div class="container mt-100 mt-60">
    <div class="row align-items-center">
      <div class="col-lg-5 col-md-6">
        <img src="assets/images/travel/2.jpg" class="img-fluid rounded shadow-md" alt="">
      </div>
      <!--end col-->

      <div class="col-lg-7 col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
        <div class="section-title ms-lg-4">
          <h4 class="title mb-4">We have More than 500 <br> Selected Events</h4>
          <p class="text-muted">You can combine all the Blimp  into a single one, you can take a servese
            from the Mobile Application  and use it in the Website.</p>
          <ul class="list-unstyled text-muted">
            <li class="mb-0"><span class="text-primary h5 me-2"><i
                  class="uil uil-check-circle align-middle"></i></span>Servese 1</li>
            <li class="mb-0"><span class="text-primary h5 me-2"><i
                  class="uil uil-check-circle align-middle"></i></span>Servese 1</li>
            <li class="mb-0"><span class="text-primary h5 me-2"><i
                  class="uil uil-check-circle align-middle"></i></span>Servese 1</li>
          </ul>
          <a href="javascript:void(0)" class="mt-3 h6 text-primary">Search Destination <i
              class="uil uil-angle-right-b"></i></a>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>
  <!--end container-->

  <div class="container mt-100 mt-60">
    <div class="row justify-content-center">
      <div class="col-12 text-center">
        <div class="section-title mb-4 pb-2">
          <h4 class="title mb-4">Whats Our Clients Said About <span class="text-primary">Blimp</span> App</h4>
          <p class="text-muted para-desc mx-auto mb-0">Start working with <span
              class="text-primary fw-bold">Blimp</span> that can provide everything you need to generate awareness,
            drive traffic, connect.</p>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->

    <div class="row justify-content-center">
      <div class="col-lg-12 mt-4">
        <app-testimonial [testimonialData]="testimonialData"></app-testimonial>
      </div>
      <!--end col-->
    </div>
  </div>
  <!--end container-->
</section>
<!--end section-->

<!-- Back to top -->
<a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" [ngxScrollTo]="'#home'">
  <i-feather name="arrow-up" class="icons"></i-feather>
</a>